import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withData } from "../common/WithData";
import StudentController from "../api/StudentController";
import { Container, Row, Col } from "react-bootstrap";
import EmergencyContactsView from "../components/EmergencyContactsView";
import MissingPersonView from "../components/MissingPersonContactsView";
import ErrorBoundary from "./ErrorBoundry";

class EmergencyContacts extends React.Component
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);

        this.studentController = new StudentController();
    }

    render(): React.ReactNode
    {
        const EmergencyContactsData = withData(
            EmergencyContactsView,
            "Emergency Contact",
            async () => await this.studentController.getEmergencyContacts()
        );

        const MissingPersonData = withData(
            MissingPersonView,
            "Missing Person",
            async () => await this.studentController.getMissingPersonContacts()
        );

        return <Fragment>
            <ErrorBoundary>
                <Row>
                    <Col lg={6} className="right-border">
                        <h2>Emergency Contact(s)</h2>
                        <EmergencyContactsData />
                    </Col>
                    <Col lg={6}>
                        <h2>Missing Person Contact(s)</h2>
                        <MissingPersonData />
                    </Col>
                </Row>
            </ErrorBoundary>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent
});

export default connect(mapStateToProps)(EmergencyContacts);